<template>
  <div class="table" ref="tableContainer">
    <div class="table-left" ref="tableLeft">
      <img :src="list.cover" alt="" />
    </div>
    <div class="table-right">
      <el-table :data="tableData" :style="{ width: tableWidth + 'px' }">
        <el-table-column v-for="(item, index) in culomns" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Object,
  },
  data() {
    return {
      tableData: [],
      culomns: [],
      tableWidth: 972, // 初始宽度减去边距或其他固定宽度元素
    };
  },
  watch: {
    list: {
      handler(newVal) {
        this.tableData = newVal.data;
        this.culomns = newVal.culomn;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.updateTableWidth();
    window.addEventListener('resize', this.updateTableWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableWidth);
  },
  methods: {
    updateTableWidth() {
      this.tableWidth = this.$refs.tableContainer.offsetWidth - this.$refs.tableLeft.offsetWidth - 40;
      const flexWidth = this.culomns.reduce((a, b) => {
        return a.flex + b.flex;
      });
      for (let index = 0; index < this.culomns.length; index++) {
        this.culomns[index].width = (this.culomns[index].flex / flexWidth) * this.tableWidth;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table {
  display: flex;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  .table-left {
    // width: 23%;
    max-width: 448px;
    min-width: 408px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(247, 253, 255, 1);
    border: 1px solid rgba(204, 239, 252, 1);
    box-sizing: border-box;
  }
  .table-right {
    width: auto;
    /deep/ .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          .has-gutter {
            .el-table__cell {
              background-color: #73d3f6;
              color: #ffffff;
              border-right: 1px solid #fff;
              box-sizing: border-box;
              font-size: 18px;
              height: 51px;
            }
          }
        }
      }
      .el-table__body-wrapper {
        .el-table__body {
          .el-table__row {
            font-size: 18px;
            height: 51px;
            font-weight: 500;
          }
          .el-table__row:nth-child(2n) {
            background-color: #cceffc;
            .el-table__cell {
              border-right: 1px solid #fff;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/components/customTable.vue